const XLSX = require("xlsx-js-style");

const categoryHub = {
	settings: {
		variantAPI: 'wp-json/viking/v1/categoryhub',
		loader: null,
		loaderTextTimeout: null,
		withoutPrice: false
	},
	init() {
		this.makeRequest();
		this.cascadeInputs();

		this.settings.loader = document.querySelector('.loaderContainer');
	},
	cascadeInputs() {
		const inputs = document.querySelectorAll('.browse-category__container input');
		const downloadSelectedBtn = document.querySelector('#download-selected');

		inputs.forEach(input => {
			input.addEventListener('change', () => {
				const children = input.parentElement.nextElementSibling?.querySelectorAll('input[type="checkbox"]');

				if (children) {
					children.forEach(child => {
						child.checked = input.checked;
					});
				}
				const checkedInputs = document.querySelectorAll('.browse-category__container input.at-the-bottom:checked');

				if ( checkedInputs.length > 0 ) {
					downloadSelectedBtn.classList.add('active');
				} else {
					downloadSelectedBtn.classList.remove('active');
				}
			});
		})
	},
	makeRequest() {
		const btnAll = document.querySelector('#download-all');
		const btnSelected = document.querySelector('#download-selected');
		const selected = new Set();

		btnAll.addEventListener('click', () => {
			const categories = document.querySelectorAll('.browse-category__container input.at-the-bottom');
			const selectedIds = [];

			setTimeout( () => {
				this.settings.loader.querySelector('p').classList.remove('hidden');
			}, 3500 )

			categories.forEach(category => {
				const terms_id     = category.value;
				const terms_id_arr = terms_id.split(',');

				terms_id_arr.forEach(id => selectedIds.push(id));
			})

			this.chunkRequests( selectedIds );
		});

		btnSelected.addEventListener('click', () => {
			const selectedCategories = document.querySelectorAll('.browse-category__container input.at-the-bottom:checked');

			if ( selectedCategories.length === 0 ) return;

			selected.clear();

			setTimeout( () => {
				this.settings.loader.querySelector('p').classList.remove('hidden');
			}, 3500 )

			selectedCategories.forEach(category => {
				const terms_id     = category.value;
				const terms_id_arr = terms_id.split(',');

				terms_id_arr.forEach(id => selected.add(id));
			})

			this.chunkRequests( selected )
		});
	},
	chunkRequests( selected ) {
		this.settings.loader?.classList.add('active');

		function chunkArray(array, chunkSize) {
			return array.reduce((result, item, index) => {
				const chunkIndex = Math.floor(index / chunkSize);
				if (!result[chunkIndex]) {
					result[chunkIndex] = [];
				}
				result[chunkIndex].push(item);
				return result;
			}, []);
		}

		async function processChunks(chunks, createVariantsRequest) {
			const results = [];
			for (const chunk of chunks) {
				const chunkResults = await Promise.all(chunk.map(id => {
					return fetch(createVariantsRequest([id]))
						.then(response => response.json())
						.catch(err => {
							console.error(err);
							clearTimeout(loaderTextTimeout);
							throw err;
						});
				}));
				results.push(...chunkResults);
			}
			return results;
		}

		const chunks = chunkArray([...selected], 3);

		(async () => {
			try {
				const responses = await processChunks(chunks, createVariantsRequest);
				const data = await Promise.all(responses.map(response => response));

				let flattenedData = data.flat();

				const worksheetForHeaders = XLSX.utils.json_to_sheet(flattenedData);
				const headers = XLSX.utils.sheet_to_json(worksheetForHeaders, { header: 1 })[0];

				let elementsToMove;

				if ( categoryHub.settings.withoutPrice ) {
					elementsToMove = ['weight', 'unit'];
				} else {
					elementsToMove = ['weight', 'unit', 'quantity', 'price', 'sum_price', 'currency'];
				}

				let filteredArray = headers.filter(item => !elementsToMove.includes(item));
				let resultArray = [...filteredArray, ...elementsToMove];

				let unit = null;
				let currency = null;

				flattenedData.forEach((test, index) => {
					flattenedData[index]['price'] = flattenedData[index]['price'] * 1;

					if ( currency === null ) {
						currency = flattenedData[index]['currency'];
					}

					flattenedData[index]['weight'] = flattenedData[index]['weight'] * 1;

					if ( unit === null ) {
						unit = flattenedData[index]['unit'];
					}

					flattenedData[index]['product_name'] = categoryHub.decodeHtmlEntities( flattenedData[index]['product_name'] );
				});

				const filterPrice = document.querySelector('#without-price');

				if ( filterPrice.checked ) {
					flattenedData = flattenedData.filter(product =>
						product.price !== 0 &&
						product.price !== "" &&
						product.price != null
					  );
				}

				const worksheet = XLSX.utils.json_to_sheet(flattenedData, {header: resultArray});

				const workbook = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(workbook, worksheet, "Variants");

				const range = XLSX.utils.decode_range(worksheet["!ref"] ?? "");
				const rowCount = range.e.r;
				const columnCount = range.e.c;

				for (let col = 0; col <= columnCount; col++) {
					const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });

					worksheet[cellRef].s = {
						...worksheet[cellRef].s,
						fill: { fgColor: { rgb: "164194" } },
						font: { color: { rgb: "FFFFFF" } }
					};

					worksheet[cellRef].v = worksheet[cellRef].v.replace('pa_', '');
					worksheet[cellRef].v = worksheet[cellRef].v.replace(/_/g, ' ');

					let words = worksheet[cellRef].v.split(' ');
					for (let i = 0; i < words.length; i++) {
						words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
					}
					worksheet[cellRef].v = words.join(' ');

					const cellText = worksheet[cellRef].v;
					const cellTextLength = cellText.length;
					const cellTextWidth = (cellTextLength + 5 ) * 6;
					worksheet['!cols'] = worksheet['!cols'] || [];
					worksheet['!cols'][col] = { wpx: cellTextWidth };
				}

				let sumPriceColumn = null;
				let sumWeightColumn = null;
				for (let row = 0; row <= rowCount; row++) {
					for (let col = 0; col <= columnCount; col++) {
						const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
						const cell = worksheet[cellRef];

						if (cell?.v === "Weight") {
							sumWeightColumn = col;
						}

						if ( !categoryHub.settings.withoutPrice ) {
							if (cell?.v === "Sum Price") {
								sumPriceColumn = col;
							}

							if (col === sumPriceColumn && row > 0) {
								const quantity = XLSX.utils.encode_col(col - 2);
								const price = XLSX.utils.encode_col(col - 1);
								cell.f = `${quantity}${row + 1}*${price}${row + 1}`;
							}
						}
					}
				}

				const sumPriceLetter = XLSX.utils.encode_col(sumPriceColumn);
				const sumPriceUnitLetter = XLSX.utils.encode_col(sumPriceColumn + 1);

				const sumWeightLetter = XLSX.utils.encode_col(sumWeightColumn);
				const sumWeightUnitLetter = XLSX.utils.encode_col(sumWeightColumn + 1);

				XLSX.utils.sheet_add_aoa(
					worksheet,
					[[
						{
							v: 0, f: `SUM(${sumWeightLetter}2:${sumWeightLetter}${rowCount + 1})`,
							s: {
								fill: { fgColor: { rgb: "FFFF00" } },
								font: { color: { rgb: "FF0000" } }
							}
						}
					]],
					{ origin: `${sumWeightLetter}${rowCount + 2}` }
				);

				XLSX.utils.sheet_add_aoa(
					worksheet,
					[[
						{
							v: unit,
							s: {
								fill: { fgColor: { rgb: "FFFF00" } },
								font: { color: { rgb: "FF0000" } }
							}
						}
					]],
					{ origin: `${sumWeightUnitLetter}${rowCount + 2}` }
				);

				if ( ! categoryHub.settings.withoutPrice ) {
					XLSX.utils.sheet_add_aoa(
						worksheet,
						[[
							{
								v: 0, f: `SUM(${sumPriceLetter}2:${sumPriceLetter}${rowCount + 1})`,
								s: {
									fill: { fgColor: { rgb: "FFFF00" } },
									font: { color: { rgb: "FF0000" } }
								}
							}
						]],
						{ origin: `${sumPriceLetter}${rowCount + 2}` }
					);

					XLSX.utils.sheet_add_aoa(
						worksheet,
						[[
							{
								v: currency,
								s: {
									fill: { fgColor: { rgb: "FFFF00" } },
									font: { color: { rgb: "FF0000" } }
								}
							}
						]],
						{ origin: `${sumPriceUnitLetter}${rowCount + 2}` }
					);
				}

				XLSX.utils.sheet_add_aoa(
					worksheet,
					[[ "Disclaimer: the indicated prices are just an estimate, please get in touch with your sales representative to get the final pricing." ]],
					{ origin: `A${rowCount + 3}` }
				);

				this.settings.loader?.classList.remove('active');
				this.settings.loader.querySelector('p').classList.add('hidden');
				XLSX.writeFile(workbook, "variants.xlsx", { compression: true });
			} catch (err) {
				clearTimeout(loaderTextTimeout);
				console.error('Error processing chunks:', err);
			}
		})();

		function createVariantsRequest(variantsIds) {
			const params = new URLSearchParams();

			params.append('terms', [...variantsIds].join(','));
			params.append('user_id', category_hub.user_id);

			const withoutAttributesFilter = document.querySelector('#without-attributes');

			if ( withoutAttributesFilter.checked ) {
				params.append('without_attributes', true);
			}

			const queryString = params.toString();

			const url = `${window.location.origin}/wp-json/viking/v1/categoryhub?${queryString}`;

			return url;
		}

		const loaderText = document.querySelector('.loaderContainer p');

		var loaderTextTimeout = setTimeout(() => {
			loaderText.classList.remove('hidden');
		}, 5000);
	},
	createVariantsRequest( variantsIds ) {
		const params = new URLSearchParams();

		params.append('terms', [...variantsIds].join(','));
		params.append('user_id', category_hub.user_id);

		const queryString = params.toString();

		const url = `${window.location.origin}/${this.settings.variantAPI}?${queryString}`;

		return url;
	},
	decodeHtmlEntities(text) {
		const doc = new DOMParser().parseFromString(text, "text/html");
		return doc.documentElement.textContent;
	}
}


categoryHub.init();
